import { render, staticRenderFns } from "./BaseCarousel.vue?vue&type=template&id=5068ad2e&"
import script from "./BaseCarousel.vue?vue&type=script&lang=js&"
export * from "./BaseCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5068ad2e')) {
      api.createRecord('5068ad2e', component.options)
    } else {
      api.reload('5068ad2e', component.options)
    }
    module.hot.accept("./BaseCarousel.vue?vue&type=template&id=5068ad2e&", function () {
      api.rerender('5068ad2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseCarousel.vue"
export default component.exports